import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { EditBase, Form, required, TextInput, useRecordContext } from "react-admin";
import { reportError } from "../backoffice.utils";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Column } from "../misc/Column";
import { useQueryClient } from "react-query";
import { SaveButton2 } from "../buttons/SaveButton2";

export function EditStudentGuardianDialog(props: { open: boolean; onClose: () => void }) {
  const { open, onClose } = props;
  const student = useRecordContext<Student>();
  const queryClient = useQueryClient();

  const onSubmit = async (guardianData: Student["guardian"]) => {
    if (!student) {
      throw new Error("Invalid state: !student");
    }
    try {
      await dataProvider.update("students", {
        id: student.id,
        data: { guardian: guardianData },
        previousData: student,
      });
      await queryClient.invalidateQueries(["students", "getOne", { id: student.id }]);
      showSuccessToast(`Gesetzlicher Vertreter von ${student.name} erfolgreich geändert.`);
    } catch (error) {
      reportError(`Failed to change guardian of student ${student.id}`, error);
      showErrorToast(`Fehler beim Ändern des gesetzlichen Vertreters von ${student.name}.`);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{`Gesetzlicher Vertreter von ${student?.name ?? "..."}`}</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <EditBase>
        <Form onSubmit={(formData) => onSubmit(formData.guardian)} warnWhenUnsavedChanges>
          <DialogContent>
            <Column>
              <TextInput source="guardian.firstName" label="Vorname" validate={required()} />
              <TextInput source="guardian.lastName" label="Nachname" validate={required()} />
              <TextInput source="guardian.email" label="E-Mail" validate={required()} />
              <TextInput source="guardian.phone" label="Telefonnummer" validate={required()} />
            </Column>
          </DialogContent>
          <DialogActions>
            <SaveButton2 />
          </DialogActions>
        </Form>
      </EditBase>
    </Dialog>
  );
}
